var pym = require("./lib/pym");
var pymChild = null;
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// setup
pym.then(child => {
  pymChild = child;

  // shuffle the quote order
  shuffleQuotes("#quotes", ".quote");

  // add ".active" class to trigger animation
  setTimeout(() => {
    var quotes = document.querySelectorAll(".quote");
    quotes.forEach((q, i) => {
      q.classList.add("active");
    });
  }, "500");

  child.sendHeight();
  window.addEventListener("resize", onResize);
});

var onResize = function() {
  if (pymChild) {
    pymChild.sendHeight();
  }
}

// shuffle the quotes
// via https://stackoverflow.com/questions/43979555/javascript-shuffle-divs-within-div
var shuffleQuotes = function(c, el) {
  var container = document.querySelector(c);
  var elements = Array.prototype.slice.call(container.querySelectorAll(el));
  elements.forEach(function(element){
    container.removeChild(element);
  });
  shuffleArray(elements);
  elements.forEach(function(element, i){
    element.classList.add("quote-" + i);
    element.dataset.id = i;
    container.appendChild(element);
  })
}

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}
